export const state = () => ({
  config: {
    isSearchActive: false,
    isSidebarActive: false,
    isBackActive: false,
    isAccountNavActive: false,
    showWelcome: false
  }
})

export const getters = {
  CONFIG: state => state.config,
  IS_BACK_ACTIVE: state => state.config.isBackActive,
}

export const mutations = {
  SET_IS_SEARCH_ACTIVE(state, isActive) {
    state.config.isSearchActive = isActive
  },

  SET_IS_SIDEBAR_ACTIVE(state, isActive) {
    state.config.isSidebarActive = isActive
  },

  SET_IS_BACK_ACTIVE(state, isActive) {
    state.config.isBackActive = isActive
  },

  SET_IS_ACCOUNT_NAV_ACTIVE(state, isActive) {
    state.config.isAccountNavActive = isActive
  },

  // One-shot flag: set on a successful login, consumed once by the header
  // welcome toast, then reset. Not part of RESET_ALL (it self-resets).
  SET_SHOW_WELCOME(state, show) {
    state.config.showWelcome = show
  },

  RESET_ALL(state) {
    state.config.isSearchActive = false
    state.config.isSidebarActive = false
    state.config.isBackActive = false
    state.config.isAccountNavActive = false
  }
}